export default function PHP_strftime() {
  return (
    <div>
      <h1>PHP_strftime</h1>
    </div>
  );
}
